var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", [
        _c("div", { staticClass: "gc_mask" }),
        _c("div", { staticClass: "modal-wrap" }, [
          _c("div", { staticClass: "modal modal-transparent" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("div", {
                  staticClass: "modal-close",
                  on: { click: _vm.goClose }
                })
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _vm._v(" 下载名厨App ")
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "modal-button-group-v modal-button-group-normal"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "modal-button",
                        attrs: { role: "button" },
                        on: { click: _vm.goClose }
                      },
                      [_vm._v("下载")]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }